class MetaobjectNavigation extends HTMLElement {
  SECONDARY_NAV_SELECTOR = ".metaobject-secondary-navigation";
  PRIMARY_LINK_SELECTOR = ".primary-link-item";
  SECONDARY_LINK_SELECTOR = ".media-link-content--name";
  MEDIA_ITEM_SELECTOR = ".media-link-content-media-item";
  OVERLAY = ".metaobject-secondary-navigation-overlay";

  constructor() {
    super();
    this.addEventListener("mouseover", this.handleMouseOver.bind(this));
  }

  handleMouseOver(event) {
    const primaryLink = event.target.closest(this.PRIMARY_LINK_SELECTOR);
    const secondaryLink = event.target.closest(this.SECONDARY_LINK_SELECTOR);
    const overlay = event.target.closest(this.OVERLAY);

    if (primaryLink) {
      this.handlePrimaryLink(primaryLink);
    } else if (secondaryLink) {
      this.handleSecondaryLink(secondaryLink);
    } else if (overlay) {
      this.closeAllSecondaryNavigation();
      this.resetPrimaryLinksActiveState();
      this.resetSecondaryLinksActiveState();
    }
  }

  handlePrimaryLink(element) {
    const { primaryLinkName } = element.dataset;
    this.resetPrimaryLinksActiveState();
    element.dataset.primaryLinkItemActive = true;
    this.closeAllSecondaryNavigation();
    if (!primaryLinkName) return;
    this.openSecondaryNavigation(primaryLinkName);
  }

  handleSecondaryLink(element) {
    const { mediaLinkContentName } = element.dataset;
    this.resetSecondaryLinksActiveState();
    element.dataset.mediaLinkContentActive = true;
    if (!mediaLinkContentName) return;
    this.closeAllMediaItem();
    this.openMediaItem(mediaLinkContentName);
  }

  openSecondaryNavigation(name) {
    const secondaryNavItem = this.querySelector(
      `${this.SECONDARY_NAV_SELECTOR}[data-primary-link-name="${name}"]`
    );
    if (!secondaryNavItem) return;
    this.openDefaultMediaItem(secondaryNavItem);
    secondaryNavItem.dataset.metaobjectSecondaryNavigationVisibility =
      "visible";
  }

  openDefaultMediaItem(secondaryNavItem) {
    this.closeAllMediaItem();
    const mediaItemArray = Array.from(
      secondaryNavItem.querySelectorAll(this.SECONDARY_LINK_SELECTOR)
    );
    const defaultItem = mediaItemArray.length > 0 ? mediaItemArray[0] : null;
    if (!defaultItem) return;
    const { mediaLinkContentName } = defaultItem.dataset;
    if (!mediaLinkContentName) return;
    defaultItem.dataset.mediaLinkContentActive = true;
    this.openMediaItem(mediaLinkContentName);
  }

  openMediaItem(name) {
    this.closeAllMediaItem();
    const mediaItem = this.querySelector(
      `${this.MEDIA_ITEM_SELECTOR}[data-media-link-content-name="${name}"]`
    );
    if (!mediaItem) return;
    mediaItem.dataset.mediaLinkContentVisibility = "visible";
  }

  closeAllSecondaryNavigation() {
    this.querySelectorAll(this.SECONDARY_NAV_SELECTOR).forEach(
      (el) => (el.dataset.metaobjectSecondaryNavigationVisibility = "hidden")
    );
  }

  closeAllMediaItem() {
    this.querySelectorAll(this.MEDIA_ITEM_SELECTOR).forEach(
      (el) => (el.dataset.mediaLinkContentVisibility = "hidden")
    );
  }

  resetPrimaryLinksActiveState() {
    this.querySelectorAll(this.PRIMARY_LINK_SELECTOR).forEach(
      (item) => (item.dataset.primaryLinkItemActive = "false")
    );
  }

  resetSecondaryLinksActiveState() {
    this.querySelectorAll(this.SECONDARY_LINK_SELECTOR).forEach(
      (item) => (item.dataset.mediaLinkContentActive = false)
    );
  }
}
customElements.define("metaobject-navigation", MetaobjectNavigation);
